import type {LoginType} from '@Components/two-factor-authentication/two-factor-authentication.types';
import {useAppSelector} from '@/hooks';

export const useTwoFactorAuthenticationPanelLoginType = (): LoginType => {
  return useAppSelector((state) => {
    return state.twoFactorAuthentication.loginType;
  });
};

export const useTwoFactorAuthenticationIsLoading = (): boolean => {
  return useAppSelector((state) => {
    return state.twoFactorAuthentication.isLoading;
  });
};

export const useTwoFactorAuthenticationErrorMessage = (): string => {
  return useAppSelector((state) => {
    return state.twoFactorAuthentication.errorMessage;
  });
};

export const useTwoFactorAuthenticationIsTOTPValidated = (): boolean => {
  return useAppSelector((state) => {
    return state.twoFactorAuthentication.isTOTPValidated;
  });
};
